import { createSelector } from "@reduxjs/toolkit";

export const selectCountries = (state) => state.general.countries;
export const selectStates = (state) => state.general.states;
export const selectCities = (state) => state.general.cities;
export const selectFormStructure = (state) => state.general.form_structures;

const selectBusinessSlice = (state) => state.business;

export const selectBusinessConfigurations = createSelector(selectBusinessSlice, (state) => state.configurations)
